function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MigrationMainTemplate = require('./main.template');
var SaitoUser = require('./../../../lib/saito/ui/saito-user/saito-user');
var SaitoOverlay = require('../../../lib/saito/ui/saito-overlay/saito-overlay');
var MigrationMain = /*#__PURE__*/function () {
  function MigrationMain(app, mod) {
    _classCallCheck(this, MigrationMain);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this, false);
  }

  /**
   * First render -- manual form / disabled automated migration button
   * Second render -- enables button
   * #automatic.onclick -> launch an overlay form
   *
   */
  return _createClass(MigrationMain, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (document.querySelector('.main')) {
                this.app.browser.replaceElementBySelector(MigrationMainTemplate(this.mod), '.main');
              } else {
                this.app.browser.addElementToDom(MigrationMainTemplate(this.mod));
              }
              this.attachEvents();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var pk = this.app.browser.returnURLParameter('publickey');
      var erc20 = this.app.browser.returnURLParameter('erc20');
      var email = this.app.browser.returnURLParameter('email');
      var el = document.querySelector('#withdraw-button');
      if (pk && erc20) {
        document.querySelector('.withdraw-title').innerHTML = 'Confirm Transfer';
        document.querySelector('.withdraw-intro').innerHTML = "Please confirm your ERC20/BEP20 transfer is complete";
        document.querySelector('#withdraw-button').innerHTML = "confirm";
        document.querySelector('#email').style.display = 'none';
        document.querySelector('#publickey').style.display = 'none';
        document.querySelector('#erc20').style.display = 'none';
        el.onclick = function (e) {
          var mailrelay_mod = _this.app.modules.returnModule('MailRelay');
          if (!mailrelay_mod) {
            salert('Your Saito install does not contain email support, please write the project manually to complete token withdrawal');
            return;
          }
          var emailtext = "\n            <div>\n            <p>Dear Saitozen,</p>\n            <p>Token withdrawal requested:</p>\n          <p>From: ".concat(erc20, "</p>\n          <p>To: ").concat(pk, "</p>\n          <p>Email: ").concat(email, "</p>\n          <p>Token transfer should be recorded at:</p>\n          <p>0x24F10EA2827717770270e3cc97F015Ba58fcB9b6</p>\n            <p>-- Saito Migration Transfer Service</p>\n        ");

          // to, from, subject, text, ishtml, attachments, bcc
          mailrelay_mod.sendMailRelayTransaction({
            to: email,
            from: 'Saito Token Migration <info@saito.tech>',
            subject: 'Saito Token Withdrawal Request (action required)',
            html: emailtext,
            ishtml: true,
            bcc: 'migration@saito.io'
          });
          mailrelay_mod.sendMailRelayTransaction({
            to: 'migration@saito.tech',
            from: 'Saito Token Migration <info@saito.tech>',
            subject: 'Saito Token Withdrawal Request (action required)',
            html: emailtext,
            ishtml: true,
            bcc: 'migration@saito.io'
          });
          document.querySelector('.withdraw-intro').innerHTML = 'Your request is now processing. Please contact us by email if you do not receive confirmation of token issuance within 24 hours.';
          document.querySelector('.withdraw-title').innerHTML = 'Request in Process';
          document.querySelector('#withdraw-button').style.display = 'none';
          _this.mod.sendStoreMigrationTransaction(_this.app, _this.mod, {
            pk: pk,
            erc20: erc20,
            email: email
          });
        };
        return;
      }
      el.onclick = function (e) {
        var email = document.querySelector('#email').value;
        var erc20 = document.querySelector('#erc20').value;
        var publickey = document.querySelector('#publickey').value;
        var mailrelay_mod = _this.app.modules.returnModule('MailRelay');
        if (!mailrelay_mod) {
          salert('Your Saito install does not contain email support, please write the project manually to process token withdrawal');
          return;
        }

        //
        //
        //
        if (publickey !== _this.mod.publicKey) {
          salert('The publickey provided is not the publickey of this wallet. To avoid problems please request token withdrawal from the wallet which will receive the tokens');
          return;
        }
        var emailtext = "\n        <div>\n            <p>Dear Saitozen,</p>\n            <p>You have provided the following ERC20/BEP20 address:</p>\n            <p>".concat(erc20, "</p>\n            <p>And the following Saito address / publickey:</p>\n            <p>").concat(publickey, "</p>\n            <p>If this information is correct, complete your withdrawal by sending your ERC20 or BEP20 tokens to our monitored multisig address:</p>\n            <p>0x24F10EA2827717770270e3cc97F015Ba58fcB9b6</p>\n          <p>(Note, the address is the same on both networks.)</b>\n            <p>Once the transfer is complete, please click on the following link and confirm the submission - our team will complete the transfer within 24 hours:</p>\n            <p>http://saito.io/migration?publickey=").concat(publickey, "&erc20=").concat(erc20, "&email=").concat(email, "</p>\n            <p>Please reach out by email if you do not hear from us in a day.</p>\n            <p>-- The Saito Team</p> \n          </div>\n      ");
        mailrelay_mod.sendMailRelayTransaction({
          to: email,
          from: 'Saito Token Migration <info@saito.tech>',
          subject: 'Saito Token Withdrawal (migration)',
          html: emailtext,
          ishtml: true
        });
        mailrelay_mod.sendMailRelayTransaction({
          to: 'migration@saito.io',
          from: 'Saito Token Migration <info@saito.tech>',
          subject: 'Saito Token Withdrawal (migration)',
          html: emailtext,
          ishtml: true
        });
        document.querySelector('.withdraw-title').innerHTML = 'Email Sent';
        document.querySelector('.withdraw-intro').innerHTML = "<p>We have emailed you instructions on transferring your ERC20/BEP20 tokens and a link to report the transfer when complete.</p>\n       <p>In the event of problems please reach out directly at <i>info@saito.tech</i>.</p>";
        document.querySelector('#email').style.display = 'none';
        document.querySelector('#publickey').style.display = 'none';
        document.querySelector('#erc20').style.display = 'none';
        document.querySelector('#automatic').style.display = 'none';
        document.querySelector('#withdraw-button').style.display = 'none';
      };
      if (document.getElementById('automatic')) {
        document.getElementById('automatic').onclick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this.startAutomatedMigration();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
      }
      var network_selector = document.getElementById('wrapped-saito-ticker');
      if (network_selector) {
        network_selector.onchange = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
            var ticker, selection, crypto_mod, _t;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.p = _context3.n) {
                case 0:
                  ticker = event.currentTarget.value;
                  _this.mod.can_auto = false;
                  _this.mod.auto_migration_error = '';
                  _this.mod.balance = 0;
                  _this.mod.migration_mixin_address = '';
                  selection = _this.mod.selectWrappedSaitoTicker(ticker, true);
                  _this.render();
                  _context3.p = 1;
                  _context3.n = 2;
                  return selection;
                case 2:
                  crypto_mod = _context3.v;
                  if (!(!_this.mod.relay_available || !(crypto_mod !== null && crypto_mod !== void 0 && crypto_mod.address))) {
                    _context3.n = 3;
                    break;
                  }
                  throw new Error('Migration service is not available yet');
                case 3:
                  _context3.n = 4;
                  return _this.mod.sendMigrationPingTransaction({
                    ticker: ticker,
                    mixin_address: crypto_mod.formatAddress()
                  });
                case 4:
                  _context3.n = 6;
                  break;
                case 5:
                  _context3.p = 5;
                  _t = _context3.v;
                  console.error(_t);
                  _this.mod.auto_migration_error = (_t === null || _t === void 0 ? void 0 : _t.message) || String(_t);
                  _this.render();
                case 6:
                  return _context3.a(2);
              }
            }, _callee3, null, [[1, 5]]);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "startAutomatedMigration",
    value: function startAutomatedMigration() {
      var _this2 = this;
      var migration_data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.mod.can_auto) {
        salert('Automated migration is not available yet. Please wait a moment and try again.');
        return;
      }
      if (this.mod.balance) {
        if (migration_data.migration_type) {
          this.mod.sendMigrationPingTransaction(_objectSpread({
            ticker: this.mod.wrapped_saito_ticker,
            mixin_address: this.mod.wrappedSaitoMod.formatAddress(),
            double_check: true
          }, migration_data), true);
          return;
        }
        this.processDepositedSaito(this.mod.balance);
        return;
      }
      this.app.connection.emit('saito-backup-render-request', {
        msg: "Backup your wallet before initiating automated ".concat(this.mod.returnWrappedSaitoLabel(), " to mainnet token migration"),
        success_callback: function success_callback() {
          _this2.app.connection.emit('saito-crypto-deposit-render-request', {
            title: 'My Deposit Address',
            ticker: _this2.mod.wrapped_saito_ticker,
            warning: "<div>Reminder: send only ".concat(_this2.mod.returnWrappedSaitoLabel(), "</div><div>Max Deposit: ").concat(_this2.mod.max_deposit, "</div><div>Click <em>'Done'</em> to check on deposit.</div>"),
            migration: true,
            callback: function callback() {
              //
              // Double check the Migration bot can handle our transfer
              //
              _this2.mod.sendMigrationPingTransaction(_objectSpread({
                ticker: _this2.mod.wrapped_saito_ticker,
                mixin_address: _this2.mod.wrappedSaitoMod.formatAddress(),
                double_check: true
              }, migration_data), true);
            }
          });
        }
      });
    }

    /***
     * Final step of Automated Migration
     * */
  }, {
    key: "processDepositedSaito",
    value: function processDepositedSaito(new_balance) {
      var _this3 = this;
      var html = "\n\t\t\t<div id=\"saito-deposit-form\" class=\"saito-overlay-form saito-overlay-panel retain-surface saito-crypto-deposit saito-overlay-size narrow\">\n              <div class=\"saito-overlay-form-header\">\n                  <div class=\"saito-overlay-form-header-title\">Deposited</div>\n              </div>\n              <div class=\"saito-crypto-deposit-content\"><div>";
      if (this.mod.balance) {
        html += "<div>".concat(this.mod.balance, " ").concat(this.mod.returnWrappedSaitoLabel(), " pending conversion into </div>");
      } else {
        html += "<div>Deposited ".concat(new_balance, " ").concat(this.mod.returnWrappedSaitoLabel(), " into </div>");
      }
      html += "<div class=\"\"> ".concat(this.mod.publicKey.slice(0, 8), "...").concat(this.mod.publicKey.slice(-8), " </div>");
      if (new_balance > this.mod.max_deposit) {
        html += "<div>Click to convert the maximum of ".concat(this.mod.max_deposit, " into on chain SAITO. The remaining ").concat(Number((new_balance - this.mod.max_deposit).toFixed(8)), " SAITO will be safe on your wallet (please back it up!!!), \n          let omskian@saito [Richard] know that the migration bot is out of money. \n          When it is refilled, you'll be able to convert the rest just be revisiting this page.</div>");
      } else {
        html += "<div>Click next to convert to on chain SAITO</div></div>";
      }
      html += "</div>\n\n          <div class=\"saito-button-row\">\n             <button type=\"button\" class=\"saito-button-primary\" id='submit'>Convert</button> \n          </div>\n\n      ";
      this.overlay.show(html);
      var shiftFromSendToReceive = function shiftFromSendToReceive(robj, amount) {
        if (robj !== null && robj !== void 0 && robj.err) {
          salert('Migration Error: <br> ' + robj.err);
          return;
        }

        // Do not offer the same cached wrapped-SAITO balance for migration again while the
        // Mixin balance API catches up with the completed outbound transfer.
        _this3.mod.balance = 0;
        try {
          var _document$querySelect;
          _this3.overlay.remove();
          document.querySelector('.withdraw-title').innerHTML = 'Awaiting native SAITO';
          document.querySelector('.withdraw-intro').innerHTML = "Your ".concat(_this3.mod.returnWrappedSaitoLabel(), " transfer is complete. Waiting for native SAITO from the migration bot...");
          (_document$querySelect = document.querySelector('.withdraw-form-fields')) === null || _document$querySelect === void 0 || _document$querySelect.remove();
        } catch (err) {
          console.warn('UI errors...', err);
        }
        var hash = robj === null || robj === void 0 ? void 0 : robj.hash;
        _this3.app.connection.emit('saito-crypto-receive-render-request', {
          ticker: 'SAITO',
          amount: amount,
          publicKey: _this3.mod.migration_publickey,
          address: _this3.mod.migration_publickey,
          hash: hash,
          mycallback: function mycallback() {
            try {
              document.querySelector('.withdraw-title').innerHTML = 'Migration complete';
              document.querySelector('.withdraw-intro').innerHTML = 'Native SAITO has been issued to your wallet.';
            } catch (err) {
              console.warn('UI errors...', err);
            }
          }
        });
        _this3.app.wallet.receivePayment('SAITO', _this3.mod.migration_publickey, amount, hash);
      };
      if (document.getElementById('submit')) {
        document.getElementById('submit').onclick = function (e) {
          var sender = _this3.mod.wrappedSaitoMod.formatAddress();
          var amount = Math.min(new_balance, _this3.mod.max_deposit).toString();

          // This deterministic hash is persisted by wallet.sendPayment before the
          // wrapped-SAITO transfer. It prevents a refresh or stale balance from submitting
          // the same migration twice.
          var unique_hash = _this3.app.crypto.hash(Buffer.from(sender + _this3.mod.migration_mixin_address + amount + _this3.mod.wrapped_saito_ticker, 'utf-8'));
          if (_this3.app.wallet.doesPreferredCryptoTransactionExist(unique_hash)) {
            _this3.mod.balance = 0;
            salert("This ".concat(_this3.mod.wrapped_saito_ticker, " migration has already been submitted. Please wait for the balance and migration status to update."));
            return;
          }
          e.currentTarget.remove();
          if (document.querySelector('.saito-overlay-form-header-title')) {
            document.querySelector('.saito-overlay-form-header-title').innerHTML = "Converting ".concat(new_balance > _this3.mod.max_deposit ? 'only' : '', " ").concat(amount, " ").concat(_this3.mod.returnWrappedSaitoLabel(), "...");
          }
          var sendPaymentWrapper = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
              var res, _t2;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.p = _context4.n) {
                  case 0:
                    res = {};
                    _context4.p = 1;
                    _context4.n = 2;
                    return _this3.app.wallet.sendPayment(_this3.mod.wrapped_saito_ticker, [_this3.mod.wrappedSaitoMod.formatAddress()], [_this3.mod.migration_mixin_address], [amount], unique_hash, null, _this3.mod.migration_publickey);
                  case 2:
                    res = _context4.v;
                    _this3.app.connection.emit('saito-crypto-send-confirm', res, function () {
                      shiftFromSendToReceive(res, amount);
                    });
                    _context4.n = 4;
                    break;
                  case 3:
                    _context4.p = 3;
                    _t2 = _context4.v;
                    console.error(_t2);
                    _this3.app.connection.emit('saito-crypto-send-confirm', {
                      err: _t2
                    });
                  case 4:
                    return _context4.a(2);
                }
              }, _callee4, null, [[1, 3]]);
            }));
            return function sendPaymentWrapper() {
              return _ref3.apply(this, arguments);
            };
          }();
          _this3.app.connection.emit('saito-crypto-send-confirm-open-request', {
            ticker: _this3.mod.wrapped_saito_ticker,
            amount: amount,
            address: _this3.mod.migration_mixin_address,
            publicKey: _this3.mod.migration_publickey,
            hash: unique_hash,
            mycallback: sendPaymentWrapper
          });
        };
      }
    }
  }]);
}();
module.exports = MigrationMain;